// extracted by mini-css-extract-plugin
export default {"deleteButton":"IamRole_deleteButton__nWj6P","deleteLoad":"IamRole_deleteLoad__Pi1yU","tooltip":"IamRole_tooltip__3xCYu"};